import { render, staticRenderFns } from "./client-push-banner.vue?vue&type=template&id=cf08c298&"
import script from "./client-push-banner.vue?vue&type=script&lang=js&"
export * from "./client-push-banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports